import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4a152e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select_file" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uploadFileContainer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "imageContainer mini mt-3",
      style: _normalizeStyle('background-image: url(\'' + _ctx.publicUrl + '\')')
    }, [
      _createVNode(_component_form_field, {
        type: "file",
        "onUpdate:modelValue": _ctx.imageChangedTemp
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onUpdate:modelValue"])
    ], 4)
  ]))
}